import { Routes, Route, Navigate } from "react-router-dom"
import { AppShell } from "./components/AppShell"
import { Landing } from "./pages/Landing"
import { Samples } from "./pages/Samples"
import { SampleDetail } from "./pages/SampleDetail"
import { WhySparrow } from "./pages/WhySparrow"

function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Landing />} />
        <Route path="samples" element={<Samples />} />
        <Route path="samples/:id" element={<SampleDetail />} />
        <Route path="why-sparrow" element={<WhySparrow />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export default App
